<template>
  <Generic
    title="Consulta de protocolos"
    :protocolos="this.protocol.rows"
    name="Protocolo"
  />
</template>
<script>
import Generic from './Generic';

export default {
  components: {
    Generic
  },

  data() {
    return {
      protocol: []
    };
  }
};
</script>

<style lang="scss" scoped>
.invision-select-typing .vs__dropdown-toggle {
  height: 100%;
  padding: 0;
  border-radius: 7px;
  border: 1px solid #ced4da;
}
.invision-select-typing .vs__selected {
  padding: 4.5px 16px;
  color: #5e627a;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
}
.invision-select-typing .vs__search {
  padding: 0.4rem;
  color: #5e627a;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
}
.invision-select-typing .vs__dropdown-option {
  color: #5e627a;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
}
.invision-select-typing {
  color: #5e627a;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
}
</style>
